import HTTP from "../../http";

const STORE_ENDPOINT = "/stores";

export async function getStores() {
  return await HTTP.get(STORE_ENDPOINT);
}
